/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "planner";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface TakeoffProfileType {
}

export enum TakeoffProfileType_Enum {
  UNKNOWN = 0,
  VERTICAL = 1,
  SHALLOW = 2,
  JOYSTICK_SHALLOW = 3,
  NIGHT_AUTONOMY_VERTICAL = 4,
  NIGHT_AUTONOMY_SHALLOW = 5,
  VESSEL_MODE = 6,
  DOCK = 7,
  DOCK_NIGHT_AUTONOMY = 8,
  DOCK_SAFE = 9,
  GPS_FLIGHT = 10,
  GPS_FLIGHT_HAND_LAUNCH = 11,
  SETUP_FLIGHT = 12,
  HAND_CARRY = 13,
  UNRECOGNIZED = -1,
}

export function takeoffProfileType_EnumFromJSON(object: any): TakeoffProfileType_Enum {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return TakeoffProfileType_Enum.UNKNOWN;
    case 1:
    case "VERTICAL":
      return TakeoffProfileType_Enum.VERTICAL;
    case 2:
    case "SHALLOW":
      return TakeoffProfileType_Enum.SHALLOW;
    case 3:
    case "JOYSTICK_SHALLOW":
      return TakeoffProfileType_Enum.JOYSTICK_SHALLOW;
    case 4:
    case "NIGHT_AUTONOMY_VERTICAL":
      return TakeoffProfileType_Enum.NIGHT_AUTONOMY_VERTICAL;
    case 5:
    case "NIGHT_AUTONOMY_SHALLOW":
      return TakeoffProfileType_Enum.NIGHT_AUTONOMY_SHALLOW;
    case 6:
    case "VESSEL_MODE":
      return TakeoffProfileType_Enum.VESSEL_MODE;
    case 7:
    case "DOCK":
      return TakeoffProfileType_Enum.DOCK;
    case 8:
    case "DOCK_NIGHT_AUTONOMY":
      return TakeoffProfileType_Enum.DOCK_NIGHT_AUTONOMY;
    case 9:
    case "DOCK_SAFE":
      return TakeoffProfileType_Enum.DOCK_SAFE;
    case 10:
    case "GPS_FLIGHT":
      return TakeoffProfileType_Enum.GPS_FLIGHT;
    case 11:
    case "GPS_FLIGHT_HAND_LAUNCH":
      return TakeoffProfileType_Enum.GPS_FLIGHT_HAND_LAUNCH;
    case 12:
    case "SETUP_FLIGHT":
      return TakeoffProfileType_Enum.SETUP_FLIGHT;
    case 13:
    case "HAND_CARRY":
      return TakeoffProfileType_Enum.HAND_CARRY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TakeoffProfileType_Enum.UNRECOGNIZED;
  }
}

export function takeoffProfileType_EnumToJSON(object: TakeoffProfileType_Enum): string {
  switch (object) {
    case TakeoffProfileType_Enum.UNKNOWN:
      return "UNKNOWN";
    case TakeoffProfileType_Enum.VERTICAL:
      return "VERTICAL";
    case TakeoffProfileType_Enum.SHALLOW:
      return "SHALLOW";
    case TakeoffProfileType_Enum.JOYSTICK_SHALLOW:
      return "JOYSTICK_SHALLOW";
    case TakeoffProfileType_Enum.NIGHT_AUTONOMY_VERTICAL:
      return "NIGHT_AUTONOMY_VERTICAL";
    case TakeoffProfileType_Enum.NIGHT_AUTONOMY_SHALLOW:
      return "NIGHT_AUTONOMY_SHALLOW";
    case TakeoffProfileType_Enum.VESSEL_MODE:
      return "VESSEL_MODE";
    case TakeoffProfileType_Enum.DOCK:
      return "DOCK";
    case TakeoffProfileType_Enum.DOCK_NIGHT_AUTONOMY:
      return "DOCK_NIGHT_AUTONOMY";
    case TakeoffProfileType_Enum.DOCK_SAFE:
      return "DOCK_SAFE";
    case TakeoffProfileType_Enum.GPS_FLIGHT:
      return "GPS_FLIGHT";
    case TakeoffProfileType_Enum.GPS_FLIGHT_HAND_LAUNCH:
      return "GPS_FLIGHT_HAND_LAUNCH";
    case TakeoffProfileType_Enum.SETUP_FLIGHT:
      return "SETUP_FLIGHT";
    case TakeoffProfileType_Enum.HAND_CARRY:
      return "HAND_CARRY";
    case TakeoffProfileType_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseTakeoffProfileType(): TakeoffProfileType {
  return {};
}

export const TakeoffProfileType = {
  encode(_: TakeoffProfileType, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TakeoffProfileType {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTakeoffProfileType();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): TakeoffProfileType {
    return {};
  },

  toJSON(_: TakeoffProfileType): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<TakeoffProfileType>, I>>(base?: I): TakeoffProfileType {
    return TakeoffProfileType.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TakeoffProfileType>, I>>(_: I): TakeoffProfileType {
    const message = createBaseTakeoffProfileType();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
